import { render } from "./index.vue?vue&type=template&id=1fb9ce37&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./secondDetail.css?vue&type=style&index=0&id=1fb9ce37&scoped=true&lang=css"

import exportComponent from "/home/mali/APP_FCCBookingApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb9ce37"]])

export default __exports__